import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '../baseQuery';

type PageContextDescription = Readonly<{
  id: number;
  route_pattern: string;
  description: string;
}>;

export const pageContextDescriptionsApi = createApi({
  reducerPath: 'pageContextDescriptionsApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getPageContextDescriptions: builder.query<PageContextDescription[], undefined>({
      query: () => 'page-context-descriptions',
      keepUnusedDataFor: 60 * 60 * 24, // Cache for 24 hours
    }),
  }),
});

export const { useGetPageContextDescriptionsQuery } = pageContextDescriptionsApi;
